<template>
  <header class="sticky-header">
    <header-top-vue />
    <div class="calc-new-header calc-appoitment">
      <div
        class="float-right header-icon-contain position-relative col-12-custom canel-add-icon"
      >
        <div class="d-inline float-left">
          <a href="#" class="color-red" @click.stop.prevent="$router.go(-1)"
            >Cancel</a
          >
        </div>
        <div class="d-inline float-right">
          <a href="#" class="color-red" @click.stop.prevent="submitFormLocal"
            >Save</a
          >
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import HeaderTopVue from "../../common/HeaderTop.vue";
import { mapActions } from "vuex";

export default {
  components: {
    HeaderTopVue
  },
  methods: {
    ...mapActions("group", {
      submitForm: "submitForm"
    }),
    submitFormLocal() {
      this.submitForm();
    }
  }
};
</script>

<style scoped>
.calc-new-header {
  width: calc(100vw - 30px) !important;
}
</style>
